import { TrendingUp } from 'lucide-react';

export const INVESTOR_NAV = [
  { path: '/investor-dashboard', label: 'Dealflow', icon: TrendingUp, end: true }
];

export const INVESTOR_TITLES = {
  '/investor-dashboard': 'Investment Dealflow'
};
